import styled from 'styled-components';

export const TwoFactorValidationContainer = styled.div`
    margin-top: var(--spacing-regular);
    margin-bottom: var(--spacing-regular);
`;
